import {ITenWebProductState} from "../reducers/ten-web-product.reducer";
import {Config} from "../../config/config";
import {createFeatureSelector, createSelector} from "@ngrx/store";
import {ProductMapper} from "../../websites/website/product-mapper";
import {DbStoreState} from "../reducers";
import {Product} from "../../websites/website/product";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getTenWebProductState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.tenWebProduct);

export const getTenWebProduct = (productSlug: string) => createSelector(getTenWebProductState,
  (state: ITenWebProductState) =>
    ProductMapper.mapTenWebProduct(state.entities[productSlug])
);

export const getTenWebProducts = createSelector(getTenWebProductState,
  (state: ITenWebProductState) => {
    const websiteMap = Object.values(state.entities).reduce((websiteMapData: any, product: Product) => {
      websiteMapData[product.slug] = ProductMapper.mapTenWebProduct(product, Object.values(state.entities));
      return websiteMapData;
    }, {});
    return sortProductsByPopularRank(Object.values(websiteMap)).filter((product: Product) => !Config.servicePluginSlugs.includes(product.slug) && product.slug !== Config.builderPluginSlug); }
);


export const getTenWebProductsLoading = createSelector(getTenWebProductState,
  (state: ITenWebProductState) =>
    state.loading
);

export const getTenWebProductsLoaded = createSelector(getTenWebProductState,
  (state: ITenWebProductState) =>
    state.loaded
);

export const getTenWebManagerPlugin = createSelector(getTenWebProductState,
  (state: ITenWebProductState) =>
    ProductMapper.mapTenWebProduct(state.entities[Config.managerPluginSlug])
);


export const getTenWebTheme = createSelector(getTenWebProductState,
  (state: ITenWebProductState) =>
    ProductMapper.mapTenWebProduct(state.entities[Config.tenWebThemeSlug])
);

export const getTenWebBuilderPlugin = createSelector(getTenWebProductState,
  (state: ITenWebProductState) =>
    ProductMapper.mapTenWebProduct(state.entities[Config.builderPluginSlug])
);

const sortProductsByPopularRank = (products: Product[]): Product[] => {
  return products.sort((p1: Product, p2: Product): number => {
    if (p2.popularRank > p1.popularRank) {
      return -1;
    }
    else if (p2.popularRank < p1.popularRank) {
      return 1;
    }

    return 0;
  });
};
